import {generateFetchOptions} from '../index';

export async function getCultureAnalysisPdfData(
  surveyId: string,
  downloadToken: string,
  language: string
): Promise<Response> {
  return fetch(
    // eslint-disable-next-line max-len
    `${process.env.REACT_APP_API_HOST}/api/v1/cultural_analyses/${surveyId}/pdf_data?download_token=${downloadToken}&language=${language}`,
    generateFetchOptions({method: 'GET', isProtected: false})
  );
}
